/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserInfoVO { 
    id?: number;
    username?: string;
    anrede?: UserInfoVO.AnredeEnum;
    vorname?: string;
    nachname?: string;
    vorgestellterTitel?: string;
    nachgestellterTitel?: string;
}
export namespace UserInfoVO {
    export type AnredeEnum = 'HERR' | 'FRAU';
    export const AnredeEnum = {
        HERR: 'HERR' as AnredeEnum,
        FRAU: 'FRAU' as AnredeEnum
    };
}


